import { BreakpointValue } from "@/ui/types/layout"
import { classNames } from "@punks/ui-core"

export interface FlexContainerProps {
  horizontalBreakpoint?: BreakpointValue
  children: React.ReactNode
  className?: string
}

const FlexContainer = ({
  children,
  className,
  horizontalBreakpoint,
}: FlexContainerProps) => {
  return (
    <div
      className={classNames(
        "flex",
        {
          "flex-col": horizontalBreakpoint !== "xs",
          "flex-row": horizontalBreakpoint === "xs",
          "sm:flex-row": horizontalBreakpoint === "sm",
          "md:flex-row": horizontalBreakpoint === "md",
          "lg:flex-row": horizontalBreakpoint === "lg",
          "xl:flex-row": horizontalBreakpoint === "xl",
        },
        className
      )}
    >
      {children}
    </div>
  )
}

export default FlexContainer
